var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.closeDropdown,
          expression: "closeDropdown",
        },
      ],
      staticClass: "hcp-tag-select",
    },
    [
      _c(
        "div",
        {
          staticClass: "tag-input",
          class: { open: _vm.dropdownVisible },
          on: { click: _vm.openDropdown },
        },
        [
          _vm._l(_vm.selectedTags, function (tag) {
            return _c(
              "span",
              {
                key: tag.id,
                staticClass: "hcp-tag-chip",
                class: tag.color,
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.removeTag(tag.id)
                  },
                },
              },
              [_vm._v(" " + _vm._s(tag.name) + " × ")]
            )
          }),
          !_vm.selectedTags.length
            ? _c("span", { staticClass: "placeholder" }, [
                _vm._v("Please select tag"),
              ])
            : _vm._e(),
          _c("i", { staticClass: "el-icon-arrow-down" }),
        ],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.dropdownVisible,
              expression: "dropdownVisible",
            },
          ],
          staticClass: "tag-dropdown",
          style: _vm.dropdownStyle,
        },
        [
          _c("div", { staticClass: "drop-body" }, [
            _c(
              "div",
              { staticClass: "level1" },
              _vm._l(_vm.categories, function (category) {
                return _c(
                  "div",
                  {
                    key: category.id,
                    staticClass: "level1-row",
                    class: { active: category.id === _vm.activeCategoryId },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.activeCategoryId = category.id
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(category.name) + " ")]
                )
              }),
              0
            ),
            _c("div", { staticClass: "level2" }, [
              _c("div", { staticClass: "level2-head" }, [
                _c("span", [_vm._v(_vm._s(_vm.activeCategory.name))]),
                _c("small", [
                  _vm._v(_vm._s(_vm.selectedCountInCategory) + " selected"),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "level2-list" },
                _vm._l(_vm.activeCategory.values, function (value) {
                  return _c(
                    "div",
                    {
                      key: value.id,
                      staticClass: "option",
                      class: { checked: _vm.isSelected(value.id) },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.toggleTag(value.id)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "box" }),
                      _vm._v(" " + _vm._s(value.name) + " "),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "drop-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.clearAll.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Clear")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.closeDropdown.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Done")]
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }